// extracted by mini-css-extract-plugin
module.exports = {"OuterWrapper":"modal-module--OuterWrapper--cyiZe","InnerWrapper":"modal-module--InnerWrapper--3TW6q","CloseButton":"modal-module--CloseButton--hUNDG"};